import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import moment from "moment";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";

function AnticiposProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ANTICIPOS_PROVEEDORES = process.env.REACT_APP_URL_ANTICIPOS_PROVEEDORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [fecha, setFecha] = useState(hoy);

  const [importe, setImporte] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOC, setSelectedOC] = useState("");
  const [formaPago, setFormaPago] = useState("");
  const [observaciones, setObservaciones] = useState("NA");

  const [value, setValue] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (!value || !value._id) {
      setOrdenesCompra([]);
      setSelectedOC("");
      return;
    }
    axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const ocs = (res.data || []).filter(
          (o) => o.proveedores?.[0]?._id === value._id && o.is_active === "Si"
        );
        setOrdenesCompra(ocs);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [value]);

  const saveAnticipo = (event) => {
    event.preventDefault();
    setValidaBoton(false);
        axios.post(
          URL_ANTICIPOS_PROVEEDORES,
          {
            fecha,
            importe,
            formaPago,
            observaciones,
            bancos: selectedBanco,
            proveedores: value._id,
            ordenesCompra: selectedOC || null,
            tipoCambio: Number(tipoCambio) || 1,
            montoPesos: (Number(importe) || 0) * (Number(tipoCambio) || 1),
            utilizado: 0,
            saldo: importe,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then((data) => {

        axios
        .post(
          `${URL_MOVIMIENTOS_BANCOS}`,
          {
            fecha,
            importe: -importe,
            tipo:"Egreso",
            bancos: selectedBanco,
            anticiposProveedores:data.data._id,
            moneda:"USD"
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        )

        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Anticipo Proveedor",
            detalle: `Fecha: ${fecha} / Proveedor: ${value.nombre_comercial} / Importe: ${importe} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  const options = proveedores.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase()
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    }
  }).filter(function (el) {
    return el != null;
  });


  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="container">
          <div className="card container col-sm-8">
            <h3 align="center">Nuevo Anticipo</h3>
            <Form onSubmit={saveAnticipo}>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={6}>
                    <Label className="mr-sm-2">Observaciones</Label>
                    <Input
                      type="text"
                      value={observaciones}
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Label className="mr-sm-2">Proveedor</Label>
                    <Autocomplete
                      size="small"
                      value={value}
                      onChange={(event, selectedProveedor) => {
                        if (selectedProveedor) {
                          setValue(selectedProveedor);
                        }
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.codigo} {option.nombre_comercial}
                        </React.Fragment>
                      )}
                    />
                  </Col>
                  <Col md={6}>
                    <Label className="mr-sm-2">Forma de Pago</Label>
                    <Input
                      type="select"
                      value={formaPago}
                      onChange={(e) => {
                        setFormaPago(e.target.value);
                      }}
                    >
                      <option value="">Selecciona una Forma de Pago</option>
                      <option value="Efectivo">Efectivo</option>
                      <option value="Transfer">Transfer</option>
                      <option value="TDC">TDC</option>
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Label className="mr-sm-2">Tipo de Cambio</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={tipoCambio}
                      onChange={(e) => {
                        setTipoCambio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={6}>
                    <Label className="mr-sm-2">Orden de Compra (opcional)</Label>
                    <Input
                      type="select"
                      value={selectedOC}
                      disabled={!value || !value._id}
                      onChange={(e) => {
                        setSelectedOC(e.target.value);
                      }}
                    >
                      <option value="">Sin OC</option>
                      {ordenesCompra
                        .sort((a, b) =>
                          a.idOrdenCompra < b.idOrdenCompra ? 1 : -1
                        )
                        .map((o) => (
                          <option value={o._id}>OC {o.idOrdenCompra}</option>
                        ))}
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Label className="mr-sm-2">Banco</Label>
                    <Input
                      type="select"
                      value={selectedBanco}
                      onChange={(e) => {
                        setSelectedBanco(e.target.value);
                      }}
                    >
                      <option value="">Selecciona un Banco</option>
                      {bancos
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.banco} {a.cuenta}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col sm={6}>
                    <Label className="mr-sm-2">Importe USD</Label>
                    <CurrencyInput
intlConfig={{ locale: 'en-US', currency: 'USD' }}
                      prefix="$"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={importe}
                      className={`form-control`}
                      onValueChange={(value, name) => setImporte(value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Label className="mr-sm-2">Total en Pesos</Label>
                    <Input
                      type="text"
                      disabled
                      value={new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                      }).format((Number(importe) || 0) * (Number(tipoCambio) || 1))}
                    />
                  </Col>
                </Row>
              </FormGroup>
              <br />
              <Col>
                <Row>
                  {validaBoton ? (
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                  )}
                  <div>
                    <SweetAlert
                      show={text}
                      title="Creado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>
                  <Button
                    href="/ListadoAnticiposProveedores"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button>
                </Row>
              </Col>
            </Form>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default AnticiposProveedoresCreate;
